import { css } from 'styled-system/css';

export const Styles = {
	streamingUnactived: css({
		_mars: {
			backgroundImage: 'url(/images/common/other_bg.jpg)',
			backgroundRepeat: 'no-repeat',
			backgroundSize: 'cover',
			backgroundPosition: 'center',
			'&.video-unactivated--sport1': {
				backgroundImage: 'linear-gradient(0deg, rgba(0, 0, 0, .38), rgba(0, 0, 0, .38)), url(/images/common/soccer_bg.jpg)',
			},
			'&.video-unactivated--sport2': {
				backgroundImage: 'url(/images/common/basketball_bg.jpg)',
			},
			'&.video-unactivated--sport3': {
				backgroundImage: 'url(/images/common/football_bg.jpg)',
			},
			'&.video-unactivated--sport5': {
				backgroundImage: 'url(/images/common/tennis_bg.jpg)',
			},
			'&.video-unactivated--sport8': {
				backgroundImage: 'url(/images/common/baseball_bg.jpg)',
			},
			'&.video-unactivated--sport9': {
				backgroundImage: 'url(/images/common/badminton_bg.jpg)',
			},
			'&.video-unactivated--sport43': {
				backgroundImage: 'url(/images/common/esport_bg.jpg)',
			},
			'&.video-unactivated--sport50': {
				backgroundImage: 'url(/images/common/cricket_bg.jpg)',
			},
			'& .icon': {
				color: 'rgba(255, 255, 255, .8)',
			},
			'& .video-msg': {
				color: 'rgba(255, 255, 255, .8)',
			},
			'& .btn--primary': {
				bgColor: 'secondary.500',
				borderRadius: '6px',
			},
		}
	}),
	streamingUnactivedFixing: css({
		base: {
			display: 'contents',
		},
		_mars: {
			display: 'flex',
			alignItems: 'center',
			padding: '12px',
			gap: '9px',
			borderRadius: '6px',
			backgroundColor: 'blackOpacity.87',
			'& .icon': {
				flex: 'none',
				padding: '6px',
				borderRadius: '24px',
				height: '36px!',
				width: '36px!',
				backgroundColor: 'whiteOpacity.30',
			},
			'& .video-msg': {
				textAlign: 'left',
			}
		},
	}),
}